const ADMIN_V1 = "performly/v1"
const V1 = {
    auth: `${ADMIN_V1}/auth/profile`,
    nominations: `${ADMIN_V1}/nominations`,
    nominationsHistory: `${ADMIN_V1}/nominations/history`,
    endorsements: `${ADMIN_V1}/endorsements`,
    projects: `${ADMIN_V1}/projects`,
    projectLogo: `${ADMIN_V1}/project`,
    nominationsProjects: `${ADMIN_V1}/nomination-projects`,
    nominationsNominatedBy: `${ADMIN_V1}/nominations/nominated-by`,
    users: `${ADMIN_V1}/users`,
    meta: `${ADMIN_V1}/meta`,
    publish: `${ADMIN_V1}/publish`,
    editPublish: `${ADMIN_V1}/nominations/history`,
    s3PresignedUrl: `${ADMIN_V1}/aws/pre-signed-url`,
    awards: `${ADMIN_V1}/awards`,
    historyProjects: `${ADMIN_V1}/nominations/history/nomination-projects`,
    historyNominatedBy: `${ADMIN_V1}/nominations/history/nominated-by`,
    recognitionFor: `${ADMIN_V1}/recognition-for`,
    generalConfig: `${ADMIN_V1}/general-config`,
    publishedCount: `${ADMIN_V1}/published-count`,
    reaction: `${ADMIN_V1}/reactions`,
    editDetails: `${ADMIN_V1}/nominations/update-details`,
}
export default V1;